/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { useNavigate } from 'react-router-dom';
import { setDocuments } from '../../../common/redux/ducks/clientRegistrationForm';
import { useAppDispatch, useAppSelector } from '../../../common/redux/hooks';
import { uploadFileToBucket } from '../../../common/services/s3';
import W9Upload from './W9Upload';

export default function W9UploadPage() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const storedUUID = useAppSelector(
        ({ clientRegistration }) => clientRegistration.UUID
    );

    const handleBackClick = () => navigate(-1);
    const handleNavigationAfterSubmit = () => navigate('/client/complete');

    const handleFileUpload = async (file: File) => {
        try {
            const { storedFileUrl, key, bucket, source } =
                await uploadFileToBucket('client', storedUUID, 'w9', file);
            dispatch(
                setDocuments({
                    w9: [
                        {
                            name: file.name,
                            category: 'W9',
                            resourceType: file.type,
                            key,
                            url: storedFileUrl,
                            secureUrl: '',
                            timeStamp: new Date().toISOString(),
                            validFrom: null,
                            validTo: null,
                            taxIdNumber: null,
                            taxIdType: null,
                            bucket,
                            source,
                        },
                    ],
                })
            );
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <W9Upload
            handleBackClick={handleBackClick}
            handleNavigationAfterSubmit={handleNavigationAfterSubmit}
            handleFileUpload={handleFileUpload}
        />
    );
}
